import { useRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Carousel } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "../style.css";

const videoData = [
  {
    title: "[Sao Khuê 2025] Phần mềm quản trị mua hàng APETECHS",
    shortdesc:
      "Đứt gãy chuỗi cung ứng từ tác động của Covid-19 hay các sự kiện địa chính trị sau năm 2020 đã phát đi một cảnh báo quan trọng...",
    youtubeLink: "https://www.youtube.com/embed/cZEo6dGRDS8?si=z9JGS-EfJAxrqJoh",
  },
  {
    title: "CÔNG TY CỔ PHẦN APETECHS - GIẢI PHÁP CÔNG NGHỆ HÀNG ĐẦU VIỆT NAM",
    shortdesc:
      "Chào mừng bạn đến với APETECHS! Trong video này, chúng tôi sẽ đưa bạn vào hành trình khám phá những giải pháp công nghệ tiên tiến...",
    youtubeLink: "https://www.youtube.com/embed/XNbPUorScl4?si=THHRobibw3aY-2sc",
  },
  {
    title: "KỈ NIỆM 5 NĂM THÀNH LẬP CÔNG TY CỔ PHẦN APETECHS",
    shortdesc:
      "Hành trình 5 năm đầy tự hào và nỗ lực, từ những bước đi đầu tiên đến vị thế hiện tại...",
    youtubeLink: "https://www.youtube.com/embed/SaHrJFYkgpU?si=w5aWlC0kiQaVYhwl",
  },
];

const VideoSection = () => {
  const carouselRef = useRef<any>(null);
  const [isMobile, setIsMobile] = useState(false);
  const [activeIdx, setActiveIdx] = useState(0);
  const { t } = useTranslation('home');

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const goToPrev = () => carouselRef.current?.prev();
  const goToNext = () => carouselRef.current?.next();

  return (
    <section className="dev-video-section">
      <div className="dev-video-inner">
        <div className="dev-blog-header" style={{ marginBottom: 32 }}>
          <div>
            <span className="dev-section-comment">{t('video.label')}</span>
            <h2 className="dev-section-h2" style={{ margin: "8px 0 0" }}>{t('video.title')}</h2>
          </div>
          {!isMobile && (
            <div style={{ display: "flex", gap: 8 }}>
              <button
                className="dev-video-nav-btn"
                onClick={goToPrev}
                aria-label="Previous"
              >
                <LeftOutlined />
              </button>
              <button
                className="dev-video-nav-btn"
                onClick={goToNext}
                aria-label="Next"
              >
                <RightOutlined />
              </button>
            </div>
          )}
        </div>

        {isMobile ? (
          <div className="dev-video-stack">
            {videoData.map((item, idx) => (
              <div key={idx} className="dev-video-card">
                <div className="dev-video-iframe-wrapper">
                  <iframe
                    src={item.youtubeLink}
                    title={item.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0 }}
                  />
                </div>
                <div className="dev-video-info">
                  <div className="dev-video-title">{item.title}</div>
                  <div className="dev-video-desc">{item.shortdesc}</div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <Carousel
            ref={carouselRef}
            dots={false}
            effect="fade"
            afterChange={setActiveIdx}
          >
            {videoData.map((item, idx) => (
              <div key={idx}>
                <div className="dev-video-slide">
                  <div className="dev-video-iframe-wrapper">
                    <iframe
                      src={item.youtubeLink}
                      title={item.title}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0 }}
                    />
                  </div>
                  <div className="dev-video-info">
                    <div className="dev-video-tag">
                      <span style={{ color: "#50FA7B" }}>▶</span> Video {idx + 1} / {videoData.length}
                    </div>
                    <div className="dev-video-title">{item.title}</div>
                    <div className="dev-video-desc">{item.shortdesc}</div>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        )}

        {/* Dots indicator */}
        {!isMobile && (
          <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 20 }}>
            {videoData.map((_, i) => (
              <span
                key={i}
                style={{
                  width: i === activeIdx ? 24 : 8,
                  height: 8,
                  borderRadius: 4,
                  background: i === activeIdx ? "#FBAD16" : "rgba(255,255,255,0.15)",
                  display: "inline-block",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
                onClick={() => carouselRef.current?.goTo(i)}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default VideoSection;
